import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#/<>_";

// Decodes text with a "scan" scramble effect when it enters the viewport
export default function ScrambleText({ text, className = "", duration = 900, ...rest }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [out, setOut] = useState(text);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const revealed = Math.floor(p * text.length);
      setOut(
        text
          .split("")
          .map((c, i) =>
            i < revealed || c === " " ? c : CHARS[Math.floor(Math.random() * CHARS.length)]
          )
          .join("")
      );
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, text, duration]);

  return (
    <span ref={ref} className={className} {...rest}>
      {out}
    </span>
  );
}
